/* eslint-disable */

if (!customElements.get('subscriptions-block')) {
  class SubscriptionsBlock extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.variant = this.section.querySelector('[name="id"]')
      this.subscriptionPricesData = this.getSubscriptionPricestData()
      this.price = this.querySelector('.subscription-price')
      this.discountedPrice = this.querySelector('.subscription-discounted-price')
      this.property = this.querySelector('.subscription-property')
      this.sidebar = document.querySelector('#subscriptions-drawer')
      this.sidebarTriggers = Array.from(this.querySelectorAll('.subscription-sidebar__trigger'))
      this.feeLine = this.querySelector('[data-fee-line]')
      if (this.feeLine) {
        this.feePrice = this.feeLine.querySelector('.fee-price')
        this.feeSubtext = this.feeLine.querySelector('.fee-subtext')
        this.sansEngagementIds = (this.feeLine.dataset.sansEngagementIds || '').split(',')
        this.avecEngagementIds = (this.feeLine.dataset.avecEngagementIds || '').split(',')
        this.updateFeeDisplay()
      }

      // Widget de location (rental-widget) : cession + détail du calcul
      this.cessionValue = this.querySelector('.rental-widget__cession-value')
      this.cessionLabel = this.querySelector('.rental-widget__cession-label')
      this.detailToggle = this.querySelector('.rental-widget__detail-toggle')
      this.detailPanel = this.querySelector('.rental-widget__detail')
      if (this.detailToggle && this.detailPanel) {
        this.detailToggleLabel = this.detailToggle.querySelector('.rental-widget__detail-toggle-label')
        this.detailToggle.addEventListener('click', this.toggleDetail.bind(this))
      }

      // Rupture de stock : bandeau/bloc "prévenez-moi" + suggestions d'états disponibles
      this.stockAlternatives = this.querySelector('[data-stock-alternatives]')
      this.stockAlternativesList = this.querySelector('[data-stock-alternatives-list]')

      this.addEventListener('change', this.handleSellingPlanChange.bind(this))
      this.addEventListener('on:variant:change', this.handleVariantPickerChange.bind(this))
      this.addEventListener('click', this.handleStockAlternativeClick.bind(this))
      this.sidebarTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          this.sidebar.open()
        }.bind(this))
      }.bind(this))
    }

    /**
     * Gets the currently selected selling-plan control, whether it's a
     * native <select> (legacy widget) or a checked radio (rental widget).
     * @returns {?Element}
     */
    getSellingPlanInput() {
      return this.querySelector('select[name="selling_plan"]') || this.querySelector('input[name="selling_plan"]:checked')
    }

    /**
     * Handles 'on:variant:change' events bubbling up from the nested variant-picker
     * (fired whenever État and/or Couleur changes) to reflect stock state.
     * @param {CustomEvent} event
     */
    handleVariantPickerChange(event) {
      const { variant, product } = event.detail
      this.updateStockState(variant, product)
    }

    /**
     * Toggles the out-of-stock UI (bell-off state pills, banner, grayed-out
     * duration cards, "notify me" block) based on the currently selected variant.
     * @param {?object} variant - The variant matching the current État/Couleur selection.
     * @param {?object} product - Full product data (options/variants), from the variant-picker event.
     */
    updateStockState(variant, product) {
      const outOfStock = !(variant && variant.available)
      this.classList.toggle('rental-widget--out-of-stock', outOfStock)
      if (!outOfStock) return

      const stateName = variant.options[0]
      this.querySelectorAll('[data-stock-state-name]').forEach((el) => {
        el.textContent = stateName
      })

      this.renderStockAlternatives(variant, product)
    }

    /**
     * Renders the "Disponible tout de suite" list: other États available for the
     * currently selected Couleur, priced at the currently selected selling plan.
     * @param {object} variant
     * @param {object} product
     */
    renderStockAlternatives(variant, product) {
      if (!this.stockAlternatives || !this.stockAlternativesList) return

      const sellingPlan = this.getSellingPlanInput()?.value
      const color = variant.options[1]

      const alternatives = (product.variants || []).filter((v) => (
        v.available && v.options[1] === color && v.options[0] !== variant.options[0]
      ))

      this.stockAlternativesList.innerHTML = ''
      alternatives.forEach((v) => {
        const planData = this.subscriptionPricesData[v.id] || {}
        const price = (planData[sellingPlan] || Object.values(planData)[0])?.monthly
        if (!price) return

        const button = document.createElement('button')
        button.type = 'button'
        button.className = 'rental-widget__notify-alternative'
        button.dataset.stockAlternative = ''
        button.dataset.value = v.options[0]

        const label = document.createElement('span')
        label.className = 'rental-widget__notify-alternative-label'
        label.textContent = v.options[0]

        const priceEl = document.createElement('span')
        priceEl.className = 'rental-widget__notify-alternative-price'
        priceEl.textContent = `${price}/mois`

        button.append(label, priceEl)
        this.stockAlternativesList.appendChild(button)
      })

      this.stockAlternatives.hidden = this.stockAlternativesList.children.length === 0
    }

    /**
     * Handles a click on a "Disponible tout de suite" alternative: switches the
     * État selection in one click.
     * @param {MouseEvent} event
     */
    handleStockAlternativeClick(event) {
      const button = event.target.closest('[data-stock-alternative]')
      if (!button) return

      const radio = this.querySelector(`[data-option-index="0"] input.js-option[value="${CSS.escape(button.dataset.value)}"]`)
      if (!radio) return

      radio.checked = true
      radio.dispatchEvent(new Event('change', { bubbles: true }))
    }

    /**
     * Handles 'change' events on the element.
     */
    handleSellingPlanChange() {
      const sellingPlan = this.getSellingPlanInput()
      if (!sellingPlan) return

      const data = this.subscriptionPricesData[this.variant.value][sellingPlan.value]
      if (!data) return

      this.price.textContent = data.price
      if (this.discountedPrice) this.discountedPrice.textContent = data.discountedPrice
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.value}&selling_plan=${sellingPlan.value}`);

      if (sellingPlan.tagName === 'SELECT') {
        this.property.value = sellingPlan.selectedOptions[0].textContent
      } else {
        const label = this.querySelector(`label[for="${sellingPlan.id}"] .duration-card__label`)
        this.property.value = label ? label.textContent : sellingPlan.value
      }

      this.updateRentalRecap(data)

      if (this.feeLine) {
        this.updateFeeDisplay()
      }
    }

    /**
     * Updates the cession recap and the detail panel for the rental widget.
     * @param {object} data - Precomputed price/cession data for the selected variant + plan.
     */
    updateRentalRecap(data) {
      if (this.cessionValue) {
        this.cessionValue.textContent = data.cessionStr
      }
      if (this.cessionLabel) {
        this.cessionLabel.textContent = data.recapCessionLabel
      }

      if (this.detailPanel && data.detail) {
        const d = data.detail
        const refEl = this.detailPanel.querySelector('.rental-widget__detail-ref')
        const deductionRow = this.detailPanel.querySelector('.rental-widget__detail-deduction')?.closest('.rental-widget__detail-row')
        const deductionLabelEl = this.detailPanel.querySelector('.rental-widget__detail-deduction-label')
        const deductionEl = this.detailPanel.querySelector('.rental-widget__detail-deduction')
        const depositEl = this.detailPanel.querySelector('.rental-widget__detail-deposit')
        const soldeEl = this.detailPanel.querySelector('.rental-widget__detail-solde')
        const noteEl = this.detailPanel.querySelector('.rental-widget__detail-note')

        if (refEl) refEl.textContent = d.refStr
        if (deductionRow) deductionRow.hidden = !d.hasMonths
        if (deductionLabelEl) deductionLabelEl.textContent = d.monthsLabel
        if (deductionEl) deductionEl.textContent = `− ${d.deductionStr.replace(/^−\s*/, '')}`
        if (depositEl) depositEl.textContent = `− ${d.depositStr.replace(/^−\s*/, '')}`
        if (soldeEl) soldeEl.textContent = d.soldeStr
        if (noteEl) noteEl.innerHTML = d.floorNote
      }
    }

    /**
     * Toggles the calculation detail panel open/closed.
     */
    toggleDetail() {
      const isOpen = !this.detailPanel.hidden
      this.detailPanel.hidden = isOpen
      if (this.detailToggleLabel) {
        this.detailToggleLabel.textContent = isOpen ? 'Solde pour garder l’appareil : détail du calcul' : 'Masquer le détail du calcul'
      }
    }

    /**
     * Updates the fee line display based on selected selling plan
     */
    updateFeeDisplay() {
      if (!this.feeLine) return

      const sellingPlan = this.getSellingPlanInput()
      if (!sellingPlan) return
      const isSansEngagement = this.sansEngagementIds.includes(sellingPlan.value)

      // Get clean price text without any markup
      const priceText = this.feePrice.textContent.replace(/\s+/g, ' ').trim()

      if (isSansEngagement) {
        // Sans Engagement: normal price
        this.feePrice.innerHTML = priceText
        this.feeSubtext.innerHTML = this.feeSubtext.dataset.sansText
      } else {
        // Avec Engagement: strikethrough price
        this.feePrice.innerHTML = `<s class="price__was">${priceText}</s>`
        this.feeSubtext.innerHTML = this.feeSubtext.dataset.avecText
      }
    }

    /**
     * Gets the subscription prices data.
     * @returns {?object}
     */
    getSubscriptionPricestData() {
      const dataEl = this.querySelector('.subscription-prices-data');
      return JSON.parse(dataEl?.textContent || '{}');
    }
  }

  customElements.define('subscriptions-block', SubscriptionsBlock);
}
